import React, { useContext } from 'react';
import classnames from 'classnames';

import Context from './Context';
import ProductDetail from './ProductDetail';
import ProductTestSpecs from './ProductTestSpecs';
import ColorsGallery from '../ColorsGallery';

import ProductImage from './ProductImage';

// import futurizeImage from '../../images/futurize-logo.png';

const Body = () => {
  const {
    i18n,
    locale,
    product,
    colors,
    toggleCartColorId,
    cartColorIds,

    zoomedColorId,
    resetZoomedColor,
  } = useContext(Context);

  const {
    name,
    skebi_renders,
    skebi_custom_product_renders,
  } = product;

  const hasSkebiRenders = skebi_renders.length > 0 || skebi_custom_product_renders.length > 0;

  const className = classnames('ProductPage__Body');

  return (
    <div className={className}>
      <ColorsGallery
        i18n={i18n}
        locale={locale}
        colors={colors}
        activeColorId={zoomedColorId}
        onClose={resetZoomedColor}
        onColorAddedToCart={toggleCartColorId}
        cartColorIds={cartColorIds}
        showInfoButton={false}
      />

      <div className="row">
        <div className="col-md-4">
          <h1 className={classnames('text-success ProductPage__title', { 'ProductPage__title-futurize': hasSkebiRenders })}>
            {name}
          </h1>

          <ProductDetail />
        </div>

        <div className="col-md-8">
          <ProductImage product={product} />
        </div>
      </div>

      <ProductTestSpecs />
    </div>
  );
};

export default Body;
